"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_images_1 = __importStar(require("react-images"));
var react_photo_gallery_1 = __importDefault(require("react-photo-gallery"));
var lauterbad_common_1 = require("@eimerreis/lauterbad-common");
var GalleryWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    background: #f8f6d9;\n    box-shadow: inset 0px 2px 20px -6px #000;\n\n    img {\n        margin: 0;\n    }\n"], ["\n    width: 100%;\n    background: #f8f6d9;\n    box-shadow: inset 0px 2px 20px -6px #000;\n\n    img {\n        margin: 0;\n    }\n"])));
var ImageWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: rgb(238, 238, 238);\n    box-sizing: border-box;\n    float: left;\n    padding-bottom: 16%;\n    position: relative;\n    width: calc(25% - 4px);\n    margin: 2px;\n    overflow: hidden;\n"], ["\n    background-color: rgb(238, 238, 238);\n    box-sizing: border-box;\n    float: left;\n    padding-bottom: 16%;\n    position: relative;\n    width: calc(25% - 4px);\n    margin: 2px;\n    overflow: hidden;\n"])));
var Image = styled_components_1["default"].img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n    object-fit: cover;\n"], ["\n\n    object-fit: cover;\n"])));
var ImageGallery = /** @class */ (function (_super) {
    __extends(ImageGallery, _super);
    function ImageGallery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            // todo: make transform size configurable
            images: _this.props.blok.Images.map(function (x) { return ({ source: lauterbad_common_1.TransformImage(x.filename, "1920x0", "smart/filters:quaility(90)") }); }),
            modalOpen: false,
            selectedIndex: 0
        };
        _this.toggleLightbox = function (index) {
            _this.setState({ modalOpen: !_this.state.modalOpen });
            if (index) {
                _this.setState({ selectedIndex: index });
            }
        };
        return _this;
    }
    ImageGallery.prototype.componentDidMount = function () {
        if (typeof window !== undefined) {
            var width_1 = lauterbad_common_1.WindowService.GetWindowDimensions().width;
            if (width_1 < 1920) {
                var resizedImages = this.props.blok.Images.map(function (x) { return ({ source: lauterbad_common_1.TransformImage(x.filename, width_1.toFixed(0) + "x0", "smart/filters:quaility(90)") }); });
                this.setState({ images: resizedImages });
            }
        }
    };
    ImageGallery.prototype.render = function () {
        var _this = this;
        var galleryImages = this.props.blok.Images.map(function (x, index) {
            var transformation = "300x300";
            return {
                height: 1,
                src: lauterbad_common_1.TransformImage(x.filename, transformation, "smart/filters:quality(90)"),
                width: 1
            };
        });
        return (React.createElement(GalleryWrapper, null,
            React.createElement(react_photo_gallery_1["default"], { onClick: function (event, imageProps) { return _this.toggleLightbox(imageProps.index); }, photos: galleryImages }),
            React.createElement(react_images_1.ModalGateway, null, this.state.modalOpen ? (React.createElement(react_images_1.Modal, { onClose: function (event) { return _this.toggleLightbox(); } },
                React.createElement(react_images_1["default"], { currentIndex: this.state.selectedIndex, views: this.state.images }))) : null)));
    };
    return ImageGallery;
}(React.Component));
exports.ImageGallery = ImageGallery;
var templateObject_1, templateObject_2, templateObject_3;
